import * as types from '../mutation-types'
import Http from 'utils/http'

let simulatingRequest = null;


export const all = ({ dispatch }, site, includes = [], query = {}) => {
	return Http.include(includes).query(query).get(`sites/${site}/ferments`).then(response => {
		dispatch(types.SET_FERMENTS, response.body.data);
	});
}

export const get = ({ dispatch }, site, fermenter, ferment, includes = []) => {
	return Http.include(includes).get(`sites/${site}/fermenters/${fermenter}/ferments/${ferment}`).then(response => {
		dispatch(types.SET_ACTIVE_FERMENT, response.body.data);

		return response;
	});
}

export const update = ({ dispatch }, site, fermenter, ferment) => {
	return Http.before(request => {
		if (simulatingRequest) {
			simulatingRequest.abort();
		}
	}).put(`sites/${site}/fermenters/${fermenter}/ferments/${ferment.id}`, ferment);
}

export const store = ({ dispatch }, site, fermenter, ferment) => {
	return Http.post(`sites/${site}/fermenters/${fermenter}/ferments`, ferment).then(response => {
		return response;
	});
}

export const simulation = ({ dispatch }, site, ferment, force = false) => {
	return Http.query({ fresh: force ? 'yes' : 'no' }).before(request => {
		if (simulatingRequest) {
			simulatingRequest.abort();
		}

		simulatingRequest = request;
	}).get(`sites/${site}/ferments/${ferment}/simulate`);
}

export const temporarySimulation = ({ dispatch }, site, ferment, data) => {
	return Http.before(request => {
		if (simulatingRequest) {
			simulatingRequest.abort();
		}

		simulatingRequest = request;
	}).post(`sites/${site}/ferments/${ferment}/simulate`, data);
}

export const archive = ({ dispatch }, site, fermenter, ferment) => {
	return Http.post(`sites/${site}/fermenters/${fermenter}/ferments/${ferment}/archive`);
}

export const destroy = ({ dispatch }, site, fermenter, ferment) => {
	return Http.destroy(`sites/${site}/fermenters/${fermenter}/ferments/${ferment}`);
}

export const move = ({ dispatch }, site, fermenter, ferment, payload) => {
	return Http.post(`sites/${site}/fermenters/${fermenter}/ferments/${ferment}/move`, payload);
}



// WEBPACK FOOTER //
// ./src/vuex/actions/ferments.js